import { render, staticRenderFns } from "./CropHerbicides.vue?vue&type=template&id=016f7fcf&"
import script from "./CropHerbicides.vue?vue&type=script&lang=js&"
export * from "./CropHerbicides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports